import lodash from 'lodash'

const baseChartsMixins = {
    props: {
        title: {
            type: String,
            required: true
        },
        height: {
            type: String,
            default: '240px'
        },
        data: {
            type: Array,
            required: true
        },
        dimension: {
            type: String,
            required: true
        },
        setting: {
            type: Object,
            required: true
        },
        subGroup: {
            type: String
        },
        statsTypeList: {
            type: Array,
            default: () => {
                return ['day', 'month', 'year']
            }
        },
        statsType: {
            type: String,
            default: 'day'
        }
    },
    data () {
        return {
            currentSubType: undefined,
            currentStatsType: this.statsType,
            chartObj: null
        }
    },
    methods: {
        onSetOption (charts) {
            this.chartObj = charts;
        },
        onAfterConfig (config) {
            return config;
        },
        onStatsTypeChange (value) {
            this.$emit('statsTypeChange', value);
        }
    },
    computed: {
        chartData () {
            let tempList = [];
            if (this.subGroup == null) {
                tempList = this.data;
            } else {
                tempList = this.data.filter((item) => {
                    return item[this.subGroup] === this.currentSubType;
                });
            }

            tempList = tempList.map((item) => {
                let temp = {...item};
                temp[this.dimension] = temp[this.dimension] + '';
                return temp;
            });

            return {
                rows: tempList
            }
        },
        chartSetting () {
            return {...this.setting, dimension: [this.dimension]};
        },
        subGroupDatas () {
            let temp = new Set();
            if (this.subGroup != null) {
                this.data.reduce((retObj, item) => {
                    return retObj.add(item[this.subGroup]);
                }, temp);
            }

            let retList = Array.from(temp);

            if (retList.length > 0) {
                this.currentSubType = retList[0];
            }

            return retList;
        }
    },
    watch: {
        chartData: {
            handler (newValue) {
                setTimeout(() => {
                    if (this.chartObj) this.chartObj.resize();
                }, 100);
            }
        },
        statsType: {
            handler (newValue) {
                this.currentStatsType = newValue;
                this.onStatsTypeChange(newValue);
            }
        }
    }
}

export default baseChartsMixins;



// WEBPACK FOOTER //
// ./src/components/BaseCharts/chartBaseMixins.js